import { render, staticRenderFns } from "./invoiceReports.vue?vue&type=template&id=38ed836e&scoped=true"
import script from "./invoiceReports.vue?vue&type=script&lang=js"
export * from "./invoiceReports.vue?vue&type=script&lang=js"
import style0 from "./invoiceReports.vue?vue&type=style&index=0&id=38ed836e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ed836e",
  null
  
)

export default component.exports